import { Component } from "react"

/* Redux */
import { connect } from "react-redux"

/* Components */
import { Layout, Tag, Pagination } from "../../components"

/* REST API */
import { list, remove } from "../../api/Role"

/* Helpers */
import { withRouter, utils } from "../../helpers"

/* React Router */
import { Link } from "react-router-dom"

/* Swal */
import Swal from "sweetalert2"

/* Translate */
import { t } from "../../translates/translate"

/* Fields */
const PERCENTAGE = 95 / 2


/* Page Roles */
class Roles extends Component {

    constructor() {
        super()

        this.state = {
            data: [],
            status: "loading",
            count: 0,
        }
    }

    componentDidMount = () => {
        this.load()
    }

    componentDidUpdate = (prevProps) => {
        const { params } = this.props
        const { page } = params

        if (prevProps.params.page !== page) {
            this.load()
        }
    }

    /* Get Page */
    getPage = () => {

        const { params } = this.props
        const { page } = params

        if (Number.isInteger(parseInt(page))) {
            return parseInt(page)
        }

        return 1
    }

    /* Load action */
    load = (reload = false) => {

        const page = this.getPage()

        if (reload) {
            this.setState({ status: "loading" })
        }

        list(page).then((response) => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data.list, count: response.data.count })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: [], count: 0 })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: [], count: 0 })
            }
            else {
                this.setState({ status: "error", data: [], count: 0 })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [], count: 0 })
        })

    }


    /* Remove action */
    remove = (id) => {

        const { data } = this.state

        Swal.fire({
            title: t("swal.deleteConfirm"),
            text: t("swal.deleteWarning"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#f44336",
            reverseButtons: true,
            confirmButtonText: t("swal.deleteButton"),
            cancelButtonText: t("swal.cancelButton"),
        }).then((result) => {
            if (result.isConfirmed) {
                remove({ id }).then((response) => {
                    if (response.status === 200) {
                        const index = data.findIndex((e) => parseInt(e.id) === parseInt(id))

                        if (index > -1) {
                            const newData = data
                            newData.splice(index, 1)
                            this.setState({ data: newData })
                        }

                        Swal.fire(utils.notification(t("role.deletedSuccess"), "success"))
                    }
                    else if (response.status === 401 || response.status === 403) {
                        Swal.fire(utils.notification(t("swal.noAccess"), "error"))
                    }
                    else if (response.status === 498) {
                        Swal.fire(utils.notification(t("swal.invalidKey"), "error"))
                    }
                    else {
                        Swal.fire(utils.notification(t("swal.generic"), "error"))
                    }
                }).catch(() => {
                    Swal.fire(utils.notification(t("swal.generic"), "error"))
                })
            }
        })
    }

    render = () => {

        const { status, data, count } = this.state
        const { navigate } = this.props
        const page = this.getPage()

        if (status !== "ok") {
            return <Layout status={status} reload={() => this.load(true)} />
        }

        return (
            <div className="page">

                <div className="page-header">
                    <h1>{t("role.title")}</h1>
                    <Link to="/role/create" className="button">
                        <img src="/images/plus.png" alt="Plus" />
                        <span>{t("role.add")}</span>
                    </Link>
                </div>

                <div className="page-table">

                    <div className="page-table-header">
                        <div className="page-table-column number">#</div>
                        <div className="page-table-column" style={{ width: `${PERCENTAGE}%` }}>{t("role.name")}</div>
                        <div className="page-table-column" style={{ width: `${PERCENTAGE}%` }}>{t("role.accessCount")}</div>
                        <div className="page-table-column more"></div>
                    </div>

                    {data.map((item, index) =>
                        <div className="page-table-body" key={`${index}`}>
                            <div className="page-table-column number">{page * (index + 1)}</div>
                            <div className="page-table-column" style={{ width: `${PERCENTAGE}%` }}>{item.name}</div>
                            <div className="page-table-column" style={{ width: `${PERCENTAGE}%` }}><Tag color="green">{item.permissions} {utils.permissionText(item.permissions)}</Tag></div>

                            <div className="page-table-column more">

                                <div className="more-dropdown-menu-icon">
                                    <img src="/images/dots-more.png" alt="More Dot" />
                                </div>

                                <div className="more-dropdown-menu">

                                    <Link to={`/role/edit/${item.id}`} className="more-dropdown-menu-item">
                                        <img src="/images/editing.png" alt="Edit" />
                                        <span>{t("role.edit")}</span>
                                    </Link>

                                    <div onClick={() => this.remove(item.id)} className="more-dropdown-menu-item red">
                                        <img src="/images/remove.png" alt="Remove" />
                                        <span>{t("role.delete")}</span>
                                    </div>

                                </div>

                            </div>

                        </div>
                    )}

                    <Pagination size={10} page={page} total={count} onPageChange={(page) => navigate(`/role/${page}`)} />

                </div>

            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(withRouter(Roles))
